import { StatusBadge } from "@/components/StatusBadge";
import type { MachineDetail } from "@/features/lines/hooks";
import { formatRelativeTime } from "@/lib/display-labels";

interface StatusSectionProps {
  machine: MachineDetail | undefined;
}

export function StatusSection({ machine }: StatusSectionProps) {
  if (!machine) return null;
  return (
    <div className="space-y-1 border-t pt-3 text-sm">
      <div className="flex items-center justify-between">
        <span className="text-muted-foreground">Status atual</span>
        <StatusBadge status={machine.status} kind="machine" />
      </div>
      {machine.statusSince ? (
        <p className="text-xs text-muted-foreground">
          Desde {formatRelativeTime(machine.statusSince)}
        </p>
      ) : null}
    </div>
  );
}
